// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_square_grooved_shell/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_square_grooved_shell: ModuleSchema = {
  "id": "core_square_grooved_shell",
  "uniqueId": "B3D_GRV02",
  "createdAt": "2026-10-10T15:35:25.670Z",
  "updatedAt": "2026-10-10T15:43:25.344Z",
  "label": "Square Grooved Shell",
  "description": "Khối trụ mẫu với rãnh vuông/chữ nhật chạy dọc quanh vỏ.",
  "category": "core_geometry",
  "tags": [
    "core",
    "geometry",
    "shell",
    "groove",
    "square"
  ],
  "sliders": [
    {
      "key": "radius",
      "label": "Shell Radius",
      "min": 8,
      "max": 80,
      "step": 1,
      "default": 28,
      "unit": "mm"
    },
    {
      "key": "height",
      "label": "Shell Height",
      "min": 8,
      "max": 80,
      "step": 1,
      "default": 24,
      "unit": "mm"
    },
    {
      "key": "grooveCount",
      "label": "Number of Vertical Grooves",
      "min": 0,
      "max": 48,
      "step": 1,
      "default": 24
    },
    {
      "key": "grooveEndMargin",
      "label": "Groove End Margin",
      "min": 0,
      "max": 12,
      "step": 0.5,
      "default": 1.5,
      "unit": "mm"
    },
    {
      "key": "grooveWidth",
      "label": "Square Groove Width",
      "min": 0.4,
      "max": 8,
      "step": 0.1,
      "default": 1.2,
      "unit": "mm"
    },
    {
      "key": "grooveDepth",
      "label": "Square Groove Depth",
      "min": 0,
      "max": 10,
      "step": 0.1,
      "default": 1.2,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "shell",
      "label": "Square Grooved Shell",
      "default": "#ffffff",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "name": "Square Grooved Shell",
      "parts": [
        {
          "name": "Square Grooved Shell",
          "groupId": 0
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "name": "Square Grooved Shell",
      "groupId": 0
    }
  ]
};
